/**
  * Test if a password contains at least one alphanumeric character
  * @param {String} password
  * @returns {Boolean}
  */
export const validatePasswordAlphaNum = password => new RegExp(/(.*[A-Z0-9])/, "g").test(password);

/**
  * Regex to test for if special charachter exists in password
  * @param {String} password
  * @returns {Boolean}
  */
export const validatePasswordSpecialChar = password => new RegExp(/(.*[^\w])/, "ig").test(password);
